import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import { OperationRoutes } from '@ripeurs/common/types/gateway';

import { ApiV2Service } from '~app/services/api-v2.service';
import { UserService } from '~app/services/user.service';


@Injectable()
export class UtilityOperationHandler {
	constructor(
		private readonly _api: ApiV2Service,
		private readonly _user: UserService,
	) {}

	public postOperation({ orderId, truckId }: { orderId: string, truckId: string }) {
		return this._api.request<OperationRoutes.PostOperation.Def>(
			OperationRoutes.PostOperation.config,
			{ body: { orderId, truckId } },
		).pipe(map((result) => {
			if (result.code !== 'CREATED') throw new Error(result.code);
			return result.data.operation;
		}));
	}

	public getOperation({ id }: { id: string }) {
		return this._api.request<OperationRoutes.GetOperation.Def>(
			OperationRoutes.GetOperation.config,
			{ params: { id } },
		).pipe(map((result) => {
			if (result.code === 'NOT_FOUND') return null;

			const [operation] = this.operationTyper([result.data.operation]);
			return operation;
		}));
	}

	public getOperations({ truckId }: { truckId?: string }) {
		return this._api.request<OperationRoutes.GetOperations.Def>(
			OperationRoutes.GetOperations.config,
			{ query: { regionId: this._user.loggedGetRegion().id, truckId } },
		).pipe(map((result) => {
			if (result.code === 'ERROR_DEPENDENCY_NOT_FOUND') throw new Error('ERROR_DEPENDENCY_NOT_FOUND');
			if (result.code !== 'OK') throw new Error(result.code);

			return this.operationTyper(result.data.operations);
		}));
	}

	public getOperationsFull({ truckId }: { truckId?: string }) {
		return this._api.request<OperationRoutes.GetOperationsFull.Def>(
			OperationRoutes.GetOperationsFull.config,
			{ query: { regionId: this._user.loggedGetRegion().id, truckId } },
		).pipe(map((result) => {
			if (result.code !== 'OK') throw new Error(result.code);

			return this.operationTyper(result.data.operations).sort((a, b) => {
				const dateA = a.createdAt ? new Date(a.createdAt).getTime() : Number.POSITIVE_INFINITY;
				const dateB = b.createdAt ? new Date(b.createdAt).getTime() : Number.POSITIVE_INFINITY;

				return dateA - dateB;
			});
		}));
	}

	private operationTyper(operations: any[]): any[] {
		for (const operation of operations) {
			for (const key in operation.statutes) {
				const status = operation.statutes[key];
				status.createdAt = new Date(status.createdAt);
			}
			operation.createdAt = new Date(operation.createdAt);
			operation.updatedAt = new Date(operation.updatedAt);

			if (operation.order !== undefined) {
				operation.order.createdAt = new Date(operation.order.createdAt);
				operation.order.updatedAt = new Date(operation.order.updatedAt);
			}
		}
		return operations;
	}
}
